import { useMutation } from '@tanstack/react-query';
import { getUploadedFiles } from '../requests/uploadFile';

const KEY = 'uploadedFiles';

const useGetUploadedFiles = () => useMutation({
  mutationKey: [KEY, 'getAll'],
  mutationFn: (data) => getUploadedFiles(data),
});

const uploadedFilesMutations = {
  useGetUploadedFiles,
};

export default uploadedFilesMutations;
